 <!--Designed & Developed by:
    Nirmal K (@cyberwizard1001)⁶
    Nitin Ravi (@nitinravi)
    Ritwik M (@ritwik-m) &
    Nalinadevi K 
 for the Ministry of Education (MOE) virtual-labs project, Govt. Of India -->

 <template>
    <main class="app">
        <div class="box">
            <h1>Instructions</h1>
            <ol>
                <li class="arrow">In this section of the experiment, we'll be writing code to implement decorators in Java.</li>
                <li class="arrow">Customer, Exec, Person, Hiring Vehicle, Reservation, Reservation System and Vehicle classes have been implemented and are to be referred to.</li>
                <li class="arrow">To implement decorators, code the Weekend decorator, afternoon decorator, peak season decorator, vehicle decorator class.</li>
                <li class="arrow">Finally, complete the test driver to suit the new code.</li>
                <li class="arrow">Switch between instructions, classes and the class diagram by clicking on the respective elements in the top navigation bar.</li>
                <li class="arrow">Once you're done programming, a 'Next' button will appear.</li>
            </ol>
            <button class="button-9" @click="$emit('instructions-read', true)">Begin</button>
        </div>
    </main>
</template>


<script>

</script>

<style scoped>

.app{
  background-color: #F9FAFE;
  min-height: 960px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.button-9 {
  appearance: button;
  backface-visibility: hidden;
  background-color: #405cf5;
  border-radius: 6px;
  border-width: 0;
  box-shadow: rgba(50, 50, 93, .1) 0 0 0 1px inset, rgba(50, 50, 93, .1) 0 2px 5px 0, rgba(0, 0, 0, .07) 0 1px 1px 0;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  font-family: -apple-system, system-ui, "Segoe UI", Roboto, "Helvetica Neue", Ubuntu, sans-serif;
  font-size: 100%;
  height: 44px;
  line-height: 1.15;
  margin: 12px 0 0;
  outline: none;
  overflow: hidden;
  padding: 0 25px;
  position: relative;
  text-align: center;
  text-transform: none;
  transform: translateZ(0);
  transition: all .2s, box-shadow .08s ease-in;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 200px;
}

.button-9:disabled {
  cursor: default;
}

.button-9:focus {
  box-shadow: rgba(50, 50, 93, .1) 0 0 0 1px inset, rgba(50, 50, 93, .2) 0 6px 15px 0, rgba(0, 0, 0, .1) 0 2px 2px 0, rgba(50, 151, 211, .3) 0 0 0 4px;
}


.box{
    height: 80%;
    min-height: 600px;
    width: 100%;
    padding: 25px;
    border-radius: 10px;
    margin: 30px;
    margin-top: 15px;
    line-height: 60px;
    background-color: #F9FAFE;
    box-shadow: 2px 3px 10px 2px #D7DFFF;
}

            
            
ol {
  line-height: 3;
}

ol li {
  list-style-type: none;
  counter-increment: item;
}

ol li:before {
  content: counter(item);
  display: inline-block;
  width: 15px;
  height: 25px;
  margin-right: 5px;
  background-color: #f9dd94;
  color: #7eb4e2;
  font-weight: bold;
  font-size: 140%;
  text-align: center;
  vertical-align: end;
  padding: 0 8px 8px;
  border-radius: 3px;
  line-height: 1.3;
}
    
    


</style>